var exports = {
  "Gt": "SubscriptionGiftCard.module__frame___OXBYT2",
  "Nr": "SubscriptionGiftCard.module__card___OXBYT2",
  "Qs": "SubscriptionGiftCard.module__content___OXBYT2",
  "DD": "SubscriptionGiftCard.module__title___OXBYT2",
  "QR": "SubscriptionGiftCard.module__sender___OXBYT2",
  "p0": "SubscriptionGiftCard.module__duration___OXBYT2",
  "h5": "SubscriptionGiftCard.module__status___OXBYT2",
  "qr": "SubscriptionGiftCard.module__footer___OXBYT2",
  "xX": "SubscriptionGiftCard.module__artwork___OXBYT2",
};

module.exports = exports;
